import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { FanvueConnectionCard } from '../components/chatting/FanvueConnectionCard';
import { ChatterMappingTable } from '../components/chatting/ChatterMappingTable';
import { ChattingOverview } from '../components/chatting/ChattingOverview';

export default function Chatting() {
  const [params, setParams] = useSearchParams();
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const result = params.get('fanvue');
    if (!result) return;
    if (result === 'connected') toast.success('Fanvue connected');
    else toast.error(`Fanvue connection failed (${params.get('reason') || 'unknown'})`);
    setParams({}, { replace: true });
  }, [params, setParams]);

  return (
    <div className="space-y-10" data-testid="chatting-page">
      <ChattingOverview title="Chatting" subtitle="Fanvue chatter stats, pay rate and team links" refreshKey={refreshKey} />
      <FanvueConnectionCard onChange={() => setRefreshKey(k => k + 1)} />
      <ChatterMappingTable refreshKey={refreshKey} onChange={() => setRefreshKey(k => k + 1)} />
    </div>
  );
}
